import { createFeatureSelector } from '@ngrx/store';
import { FeatureFlagsActions, FeatureFlagsActionTypes } from './feature-flags.actions';
import {
	FeatureFlagsState,
	initialFeatureFlagsState
} from './feature-flags.state';


export const selectFeatureFlagsState = createFeatureSelector<FeatureFlagsState>(
	'featureFlags'
);

export function reducer(
	state: FeatureFlagsState = initialFeatureFlagsState,
	action: FeatureFlagsActions
): FeatureFlagsState {
	switch (action.type) {
		case FeatureFlagsActionTypes.LoadFeatureFlags:
			return {
				...state,
				loading: true,
				error: null
			};

		case FeatureFlagsActionTypes.LoadFeatureFlagsSuccess:
			return {
				...state,
				flags: action.payload,
				loaded: true,
				loading: false,
				error: null
			};

		case FeatureFlagsActionTypes.LoadFeatureFlagsFailure:
			return {
				...state,
				loading: false,
				error: action.payload
			};

		case FeatureFlagsActionTypes.SetFeatureFlags:
			return {
				...state,
				flags: action.payload,
				loaded: true
			};

		default:
			return state;
	}
}
